import { render, staticRenderFns } from "./DOTSActivity.vue?vue&type=template&id=bc308fc6"
import script from "./DOTSActivity.vue?vue&type=script&lang=js"
export * from "./DOTSActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports